function About() {
  return (
    <main className="w-full">
      <div className="flex flex-col items-center w-full max-w-4xl mx-auto p-1 md:p-4">
        
        {/* Header */}
        <h2 className="text-3xl font-bold text-center text-gray-800 uppercase">
          Gurukul Admin App – Stay Connected, Always
        </h2>

        {/* Description */}
        <p className="mt-4 text-center text-gray-600">
          The <strong>Gurukul Senior Secondary School Admin App</strong> is the one-stop solution for staying informed and engaged with your child's school life.  
          From <strong>important notices</strong> to <strong>academic progress</strong>, everything is now at your fingertips.
        </p>

        {/* Features Section */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6 text-center">
          <div className="p-4 bg-blue-100 rounded-lg">
            <h3 className="text-lg font-semibold text-blue-800">📢 Instant Updates</h3>
            <p className="text-gray-600 text-sm">Receive real-time notifications about school events, exams, and circulars.</p>
          </div>

          <div className="p-4 bg-green-100 rounded-lg">
            <h3 className="text-lg font-semibold text-green-800">📅 School Calendar</h3>
            <p className="text-gray-600 text-sm">Never miss a school holiday, PTM, or exam date.</p>
          </div>

          <div className="p-4 bg-yellow-100 rounded-lg">
            <h3 className="text-lg font-semibold text-yellow-800">📊 Student Progress</h3>
            <p className="text-gray-600 text-sm">Track your child’s academic reports, attendance, and performance.</p>
          </div>

          <div className="p-4 bg-red-100 rounded-lg">
            <h3 className="text-lg font-semibold text-red-800">💬 Direct Communication</h3>
            <p className="text-gray-600 text-sm">Easily communicate with teachers and school administrators.</p>
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-8 border-t pt-6 text-center">
          <p className="text-gray-700">
            <strong>Developed & Maintained by YROS Software</strong>, Guwahati, Assam.
          </p>
          <p className="mt-4 text-gray-700">
            For custom software solutions, reach out to us at:
          </p>

          {/* Contact Info */}
          <div className="mt-4">
            <p className="text-lg font-semibold text-gray-900">📞 789-692-2693</p>
            <p className="text-lg font-semibold text-gray-900">📧 contactyros@gmail.com</p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default About;
